import utils from '@bigcommerce/stencil-utils';
import request from './request';
import { getCartPageOvrPricing } from '../custom/shipping/ovr-shipping';
import { bus, Events } from '../common/event-bus';

export default function () {
    const $form = $('.js-quick-add');

    function popup(form, str, delay) {
        const $skuAddPopup = $(form).find('.add-sku-item');

        $skuAddPopup.html(`${str}`);
        $skuAddPopup.fadeIn(0).delay(delay).fadeOut(0);
    }

    function processForm(event, form) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const targetForm = form;
        const sku = $(targetForm).find('[data-sku]');
        const qty = $(targetForm).find('[data-qty]');
        const url = `/cart.php?action=add&sku=${encodeURIComponent(sku.val())}&qty=${encodeURIComponent(qty.val())}`;

        const $sideCart = $('.side-cart-content');
        const $sideCartDetails = $('.side-cart-details');
        const $sideCartActions = $('.side-cart-actions');

        const options = {
            template: {
                error: 'f/b2b/quick-add-response',
                content: 'f/b2b/side-cart-content',
                details: 'f/b2b/side-cart-details',
                actions: 'f/b2b/side-cart-actions',
                newsku: 'f/b2b/side-cart-quick-add-sku',
                counter: 'f/cart/item-count',
            },
        };

        if (sku.val() && qty.val()) {
            request(url, {
                method: 'POST',
                requestOptions: options,
            }, (err, response) => {
                const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
                const cleanResponse = response.error.replace(scriptRegex, '').trim();

                if (err) {
                    throw new Error(err);
                }

                if (cleanResponse.length) {
                    popup(targetForm, cleanResponse, 4000);
                } else {
                    $sideCart.html(response.content);
                    $sideCartDetails.html(response.details);
                    $sideCartActions.html(response.actions);
                    // The swap resets the drawer's shipping line and totals to the server
                    // template, so re-run the OVR pass against the updated cart.
                    utils.api.cart.getCart({}, (cartErr, cartResponse) => {
                        if (cartErr) {
                            return;
                        }
                        const sendURL = onlineServiceUrl ?? 'https://api.storesupply.com/';
                        getCartPageOvrPricing(cartResponse?.lineItems?.physicalItems ?? null, sendURL, true);
                    });
                    $('body').trigger('cart-quantity-update', response.counter); // legacy
                    bus.emit(Events.CART_UPDATED, { quantity: response.counter });
                    bus.emit(Events.QUICK_ADD_SKU_ADDED);
                    popup(targetForm, `${qty.val()} &times ${sku.val()} added to cart`, 2000);
                }

                sku.val('');
                qty.val(1);
            });
        } else {
            popup(targetForm, $(event.currentTarget).data('error'), 2000);
        }
    }


    $form.on('submit', (event) => {
        processForm(event, event.target);
    });
}
